/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-shadow */
import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import CheckBox from '@/components/elements/Form/BetCheckBox';
import {
  BetMethod,
  FirstThreeRacerData,
  FirstThreeRacerList,
  RacerNumber,
} from '@/modelTypes';

import {
  ActionButtons,
  ButtonWrapper,
  Table,
  TableData,
  TableHeader,
  TableWrapper,
} from '../style';

interface FormationSheetProps {
  bicycleCount: number;
  racerNumbers: RacerNumber[];
  firstThreeRacerList: FirstThreeRacerList;
  setFirstThreeRacerData: React.Dispatch<
    React.SetStateAction<FirstThreeRacerData>
  >;
  isDisabledBicycleNumber: (bicycleNum: number) => boolean;
}

const FormationSheet: React.FC<FormationSheetProps> = React.memo(
  ({
    bicycleCount,
    racerNumbers,
    firstThreeRacerList,
    setFirstThreeRacerData,
    isDisabledBicycleNumber,
  }) => {
    const getBracketNumber = (bicycleNum: number) => {
      const racer = racerNumbers.find(
        racerNum => racerNum.bicycleNum === bicycleNum,
      );
      return racer!.bracketNum;
    };

    const isChecked = (arrivalNum: number, bicycleNum: number): boolean =>
      firstThreeRacerList[arrivalNum].some(
        racerNums => racerNums.bicycleNum === bicycleNum,
      );

    const handleClick = (value: string, checked: boolean) => {
      const strArray = value.split(':');
      const arrivalNum = Number(strArray[0]);
      const bicycleNum = Number(strArray[1].split('-')[0]);
      const bracketNum = Number(strArray[1].split('-')[1]);

      setFirstThreeRacerData(prev => {
        const newList = { ...prev };
        if (checked) {
          newList[BetMethod.Formation][arrivalNum].push({
            bicycleNum,
            bracketNum,
          });
        } else {
          newList[BetMethod.Formation][arrivalNum] = prev[BetMethod.Formation][
            arrivalNum
          ].filter(
            racerNums =>
              !(
                racerNums.bicycleNum === bicycleNum &&
                racerNums.bracketNum === bracketNum
              ),
          );
        }
        return newList;
      });
    };

    const arrayCheck = (arrivalNum: number) => {
      setFirstThreeRacerData(prev => {
        const newList = { ...prev };
        const activeList = racerNumbers.filter(
          rn => !isDisabledBicycleNumber(rn.bicycleNum),
        );
        newList[BetMethod.Formation][arrivalNum] = [...activeList];
        return newList;
      });
    };

    const unsetArrayCheck = (arrivalNum: number) => {
      setFirstThreeRacerData(prev => {
        const newList = { ...prev };
        newList[BetMethod.Formation][arrivalNum] = [];
        return newList;
      });
    };

    const allUnsetCheck = () => {
      setFirstThreeRacerData(prev => {
        const newList = { ...prev };
        newList[BetMethod.Formation] = [[], [], []];
        return newList;
      });
    };

    return (
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <TableHeader>1着</TableHeader>
              <TableHeader>2着</TableHeader>
              <TableHeader>3着</TableHeader>
            </tr>
          </thead>
          <tbody>
            {[...Array(bicycleCount)].map((_, i) => (
              <tr key={`tr-${i}`}>
                {[...Array(3)].map((_, j) => (
                  <TableData
                    key={`td-${j}`}
                    disabled={isDisabledBicycleNumber(i + 1)}
                  >
                    <CheckBox
                      value={`${j}:${i + 1}`}
                      checked={isChecked(j, i + 1)}
                      num={i + 1}
                      onChange={() =>
                        handleClick(
                          `${j}:${i + 1}-${getBracketNumber(i + 1)}`,
                          !isChecked(j, i + 1),
                        )
                      }
                      disabled={isDisabledBicycleNumber(i + 1)}
                    />
                  </TableData>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
        <ButtonWrapper>
          {[...Array(3)].map((_, j) => (
            <ActionButtons key={`buttons-${j}`}>
              <Button
                bgColor="secondary"
                size="s"
                radius="s"
                width="40px"
                height="40px"
                onClick={() => arrayCheck(j)}
              >
                全
              </Button>
              <Button
                bgColor="secondary"
                size="s"
                outline
                radius="s"
                width="40px"
                height="40px"
                onClick={() => unsetArrayCheck(j)}
              >
                消
              </Button>
            </ActionButtons>
          ))}
        </ButtonWrapper>
        <Button
          bgColor="secondary"
          size="xs"
          outline
          radius="s"
          height="36px"
          onClick={() => allUnsetCheck()}
        >
          買い目を全て消す
        </Button>
      </TableWrapper>
    );
  },
);

export default FormationSheet;
